import { Component, OnInit } from '@angular/core';

/**
 * Component for MOM tabs with Counsellors and Management sections
 * Management tab is visible only to specific users (Kavita Shetty, Krisha Shah, or Lead Counsellor role)
 */
@Component({
  selector: 'app-mom-tabs',
  templateUrl: './mom-tabs.component.html',
  styleUrls: ['./mom-tabs.component.scss']
})
export class MomTabsComponent implements OnInit {

  showManagementTab: boolean = false;
  currentUserName: string = '';
  currentUserRole: string = '';

  constructor() { }

  ngOnInit(): void {
    this.checkUserAccess();
  }

  /**
   * Check if current user has access to management tab
   * Access granted to: Kavita Shetty, Krisha Shah, or users with Lead Counsellor role
   */
  private checkUserAccess(): void {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    this.currentUserName = userData.userName || '';
    this.currentUserRole = userData.role || '';

    // Check if user is authorized to view management tab
    this.showManagementTab =
      this.currentUserName === 'Kavita Shetty' ||
      this.currentUserName === 'Krisha Shah' ||
      this.currentUserName === 'Master Admin' ||
      this.currentUserRole === 'Lead Counsellor';

    console.log('User Access Check:', {
      userName: this.currentUserName,
      role: this.currentUserRole,
      hasManagementAccess: this.showManagementTab
    });
  }
}
